import { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <nav className="mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-2">
              <img 
                src="https://static.readdy.ai/image/e7430320e3bc3f9244a461515e2266b3/ff55c5fd36070f5cd8d5f73f7b8b3fc3.jpeg"
                alt="錏設工程行"
                className="h-10 w-auto object-contain"
              />
              <h1 className="text-2xl font-bold text-gray-900" style={{ fontFamily: '"Pacifico", serif' }}>
                錏設工程行
              </h1>
            </Link>
          </div>

          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              <Link 
                to="/" 
                className="text-gray-900 hover:text-teal-600 px-3 py-2 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                首頁
              </Link>
              <Link 
                to="/about" 
                className="text-gray-900 hover:text-teal-600 px-3 py-2 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                關於我們
              </Link>
              <Link 
                to="/services" 
                className="text-gray-900 hover:text-teal-600 px-3 py-2 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                服務項目
              </Link>
              <Link 
                to="/projects" 
                className="text-gray-900 hover:text-teal-600 px-3 py-2 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                作品
              </Link>
              <a 
                href="mailto:info@yasheconstruction.com"
                className="bg-teal-600 text-white px-6 py-2 rounded-lg font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                聯絡我們
              </a>
            </div>
          </div>

          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-gray-900 focus:outline-none focus:text-gray-900 cursor-pointer"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white border-t">
              <Link 
                to="/" 
                className="text-gray-900 hover:text-teal-600 block px-3 py-2 text-base font-medium cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                首頁
              </Link>
              <Link 
                to="/about" 
                className="text-gray-900 hover:text-teal-600 block px-3 py-2 text-base font-medium cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                關於我們
              </Link>
              <Link 
                to="/services" 
                className="text-gray-900 hover:text-teal-600 block px-3 py-2 text-base font-medium cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                服務項目
              </Link>
              <Link 
                to="/projects" 
                className="text-gray-900 hover:text-teal-600 block px-3 py-2 text-base font-medium cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                作品
              </Link>
              <a 
                href="mailto:info@yasheconstruction.com"
                className="bg-teal-600 text-white px-6 py-2 rounded-lg font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer block text-center"
                onClick={() => setIsMenuOpen(false)}
              >
                聯絡我們
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
